export default __webpack_public_path__ + "static/media/MACS-Core Logo.5b2fff9e.png";